export const workFunctionData = {
	"Product Manager": {
		fip: {
			label: "Formulate and implement product development strategy and plans",
			keyTasks: [
				{
					label: 'Create feature descriptions for the organization’s products',
					value: 'cfd'
				},
				{
					label: 'Develop product portfolio roadmap, pricing, and launch strategies, and financial projections',
					value: 'dpp'
				},
				{
					label: 'Anticipate internal and/or external business challenges and/or regulatory issues',
					value: 'aib'
				},
				{
					label: 'Present product portfolio performance to senior stakeholders',
					value: 'pps'
				}
			]
		},
		dpd: {
			label: "Drive product development",
			keyTasks: [
				{ 
					label: 'Oversee development for a suite of products',
					value: 'odp'
				},
				{ 
					label: 'Evaluate products to identify gaps, issues with product interface, performance, and product functionalities based on market feedback',
					value: 'epg'
				},
				{ 
					label: 'Integrate feedback and requests in the ideation and development of products',
					value: 'ifr'
				},
				{ 
					label: 'Validate detailed specifications and development costing against market potential and future revenue',
					value: 'vds'
				},
				{ 
					label: 'Prioritises the development of product features against strategic goals and initiatives',
					value: 'pdf'
				},
				{ 
					label: 'Define the requirements for each feature and desired user experience',
					value: 'drf'
				},
				{ 
					label: 'Determine the timeline for development, implementation and release process for the product',
					value: 'dtd'
				}
			]
		},
		dgb: {
			label: "Develop and grow business",
			keyTasks: [
				{
					label: 'Develop marketing tactics and pricing strategies',
					value: 'dmt'
				},
				{
					label: 'Drive market research studies to explore new technology',
					value: 'dmr'
				},
				{
					label: 'Drive sales volume from specific target markets in collaboration with sales and marketing team',
					value: 'drv'
				},
				{
					label: 'Oversee the development of business proposals for new opportunities',
					value: 'odp'
				},
				{
					label: 'Identify potential partner relationships for the product',
					value: 'ppr'
				}
			]
		},
		mop: {
			label: "Manage people and organisation",
			keyTasks: [
				{
					label: 'Manage the budget expenditure and allocation across teams and projects',
					value: 'mbe'
				},
				{
					label: 'Monitor and track the achievement of the team’s achievements and key performance indicators',
					value: 'mta'
				},
				{
					label: 'Propose new operational plans, including targeted budgets, work allocations and staff forecasts',
					value: 'pop'
				},
				{
					label: 'Acquire, allocate and optimise the use of and allocation of resources',
					value: 'aao'
				},
				{
					label: 'Develop learning roadmaps to support the professional development of the team',
					value: 'dlr'
				},
				{
					label: 'Manage the performance and development process, including providing coaching and development opportunities to maximise the potential of each individual',
					value: 'mpd'
				}
			]
		}
	},
	"Project Manager": {
		dpp: {
			label: "Develop project plans",
			keyTasks: [
				{
					label: 'Conduct cost-benefit analysis and develop project plan',
					value: 'cb'
				},
				{
					label: 'Review project plans to determine time frame, funding limitations, procedures for accomplishing projects',
					value: 'rp'
				},
				{
					label: 'Estimate budgetary needs based on the project scope and anticipate future budget challenges',
					value: 'bn'
				},
				{
					label: 'Assess consolidated project plans for dependencies, gaps and continued business value',
					value: 'pp'
				}
			]
		},
		opi: {
			label: "Oversee program implementation",
			keyTasks: [
				{
					label: 'Plan and manage project compliance requirements and adherence to governance structures',
					value: 'pm'
				},
				{
					label: 'Evaluate and address external business environment changes for impact on project scope',
					value: 'eb'
				},
				{
					label: 'Plan and manage project closure and/or transitions',
					value: 'pc'
				},
				{
					label: 'Conduct project reviews to recommend changes to project schedules, cost or resource requirements',
					value: 'pr'
				},
				{
					label: 'Document and track project scope, changes, issues and risks that affect implementation',
					value: 'ps'
				},
				{
					label: 'Facilitate the daily stand-up to achieve team consensus',
					value: 'sp'
				},
				{
					label: 'Eliminate conflicts and assist in developing solutions to manage roadblocks',
					value: 'ca'
				},
				{
					label: 'Refine and manage the product backlog',
					value: 'pb'
				}
			]
		},
		mpo: {
			label: "Manage people and organisation",
			keyTasks: [
				{
					label: 'Manage project budget, work allocations, manpower and resourcing needs for the team',
					value: 'mo'
				},
				{
					label: 'Develop team members through ongoing coaching, mentoring and career discussions',
					value: 'tm'
				},
				{
					label: 'Drive performance management practices within the team in accordance with organisational policies and procedures',
					value: 'pmp'
				},
				{
					label: 'Develop initiatives to support the continuing competence and professional development of the team',
					value: 'di'
				},
				{
					label: 'Facilitate discussions, problem solving and conflict resolution',
					value: 'fd'
				}
			]
		}
	},
	"Customer Success": {
		ics: {
			label: "Implement customer success strategy",
			keyTasks: [
				{
					label: "Design initiatives and programs to drive client satisfaction, retention and lifetime value",
					value: 'dip'
				},
				{
					label: "Develop service level agreements with various functions to facilitate implementation, feedback and collaboration",
					value: 'dsl'
				},
				{
					label: "Analyse operating landscape, technology developments, and client feedback to derive insights",
					value: 'atf'
				},
				{
					label: "Determine key performance indicators and goals to measure progress and achievement of client success",
					value: 'kpi'
				}
			]
		},
		onc: {
			label: "Onboard new customers",
			keyTasks: [
				{
					label: "Manage the client onboarding process and provide recommendations to improve the process",
					value: 'cop'
				},
				{
					label: "Determine objectives and success measures of the onboarding process with the client",
					value: 'mop'
				},
				{
					label: "Design and manage delivery of client onboarding programmes",
					value: 'dmc'
				},
				{
					label: "Engage clients throughout the onboarding process to identify and address concerns, provide support,obtain feedback and understand client needs",
					value: 'eop'
				},
				{
					label: "Evaluate success of the client onboarding process and celebrate wins",
					value: 'esc'
				}
			]
		},
		ovl: {
			label: "Optimise derivable value of products and services for customers",
			keyTasks: [
				{
					label: "Conduct reviews on usage of and satisfaction with products and services to determine opportunities for optimising value for the client",
					value: 'crs'
				},
				{
					label: "Formulate solutions to address challenges, under-utilisation, and improve utilisation of solutions to deliver greater value to clients",
					value: 'fsc'
				},
				{
					label: "Create client success case studies and educational resources for internal teams and clients",
					value: 'scs'
				},
				{
					label: "Conduct sharing sessions with clients on industry best practices",
					value: 'ssc'
				},
				{
					label: "Analyse client data to improve client experience, engagement and satisfaction with the organisation’s products and services",
					value: 'cde'
				},
				{
					label: "Engage clients to understand their business challenges and variables that may impact future growth and performance",
					value: 'cbc'
				},
				{
					label: "Direct technical issues of products and services to relevant technical teams for resolution",
					value: 'dtp'
				}
			]
		},
		ltv: {
			label: "Increase customer lifetime value",
			keyTasks: [
				{
					label: "Identify opportunities for upselling and cross-selling of products and services based on analysis of the client’s business strategy, needs and maturity of technology",
					value: 'ouc'
				},
				{
					label: "Provide inputs to conceptualise new products and services and increase the value of existing products and services",
					value: 'cps'
				},
				{
					label: "Provide inputs to the sales team on securing renewal of contracts and additions to existing contracts",
					value: 'ist'
				},
				{
					label: "Manage the renewal sales cycle and pipeline",
					value: 'rsp'
				}
			]
		}
	},
	"AE": {
		nbo: {
			label: "Identify new business opportunities",
			keyTasks: [
				{
					value: "pcp",
					label: "Identify prospective clients and channel partners through online research."
				},
				{
					value: "cpb",
					label: "Conduct client and channel partner research to uncover insights on potential business needs."
				},
				{
					value: "ccp",
					label: "Conduct market research and profiling, competitive landscape analysis and client profiling."
				},
				{
					value: "ibo",
					label: "Assist with identifying new business opportunities with existing clients based on research."
				}
			]
		},
		cso: {
			label: "Convert sales opportunities to clients",
			keyTasks: [
				{
					value: "pas",
					label: "Provide administrative support to sales and business development teams."
				},
				{
					value: "mcd",
					label: "Maintain client/prospect database and documentation"
				},
				{
					value: "apc",
					label: "Assist with the preparation of client outreach and presentation materials"
				},
				{
					value: "pfc",
					label: "Perform follow-up action to close sales."
				}
			]
		},
		ibd: {
			label: "Implement business development and sales strategies",
			keyTasks: [
				{
					value: "dst",
					label: "Analyse business development and sales approaches and strategies to determine their best use within the market"
				},
				{
					value: "lgp",
					label: "Use sales tools for accurate forecasting of current and future business"
				}
			]
		}
	},
	"SDR": {
		nbo: {
			label: "Identify new business opportunities",
			keyTasks: [
				{
					value: "pcp",
					label: "Identify prospective clients and channel partners through online research."
				},
				{
					value: "cpb",
					label: "Conduct client and channel partner research to uncover insights on potential business needs."
				},
				{
					value: "ccp",
					label: "Conduct market research and profiling, competitive landscape analysis and client profiling."
				},
				{
					value: "ibo",
					label: "Assist with identifying new business opportunities with existing clients based on research."
				}
			]
		},
		cso: {
			label: "Convert sales opportunities to clients",
			keyTasks: [
				{
					value: "pas",
					label: "Provide administrative support to sales and business development teams."
				},
				{
					value: "mcd",
					label: "Maintain client/prospect database and documentation"
				},
				{
					value: "apc",
					label: "Assist with the preparation of client outreach and presentation materials"
				},
				{
					value: "pfc",
					label: "Perform follow-up action to close sales."
				}
			]
		},
		moc: {
			label: "Manage integrated marketing communications (MOC) programme",
			keyTasks: [
				{
					value: "pbs",
					label: "Participate in the conceptualisation and design development of marketing campaigns for the business."
				},
				{
					value: "psm",
					label: "Identify target client profile segments, market segments and potential marketing mix."
				},
				{
					value: "cpd",
					label: "Consolidate performance data of campaigns."
				},
				{
					value: "mic",
					label: "Monitor implementation of campaigns against planned timeline."
				}
			]
		}
	},
	"ME": {
		fdd: {
			label: "Formulate data-driven market and client insights",
			keyTasks: [
				{
					value: "mrp",
					label: "Conduct market research on trends, competitor’s product positioning, placement and pricing strategies"
				},
				{
					value: "dmd",
					label: "Analyse data obtained on clients' buying behaviours, motivation, attitudes, preferences and needs to derive client insights"
				},
				{
					value: "abd",
					label: "Analyse data from digital marketing dashboards"
				},
				{
					value: "pmi",
					label: "Propose new marketing ideas and approaches based on client insights derived from market analysis"
				}
			]
		},
		moc: {
			label: "Manage integrated marketing communications (MOC) programme",
			keyTasks: [
				{
					value: "pbs",
					label: "Participate in the conceptualisation and design development of MOC campaigns for the business and/or specific lines of product and service"
				},
				{
					value: "psm",
					label: "Identify target client profile segments, market segments and potential marketing mix for MOC campaign"
				},
				{
					value: "dmc",
					label: "Identify possible traditional and digital media channels and platforms for MOC campaign"
				},
				{
					value: "cde",
					label: "Coordinate with design teams to develop MOC campaign concept design elements and materials for traditional and digital media channels"
				},
				{
					value: "cpd",
					label: "Consolidate performance data of MOC campaigns"
				},
				{
					value: 'umc',
					label: 'Update marketing and communications content on various media and platforms'
				}
			]
		}
	},
	"PTP Coordinator": {
		"Perform financial accounting and corporate reporting activities": [
			"Perform month-end closing activities",
			"Maintain accurate financial records and statements",
			"Record and process all business transactions in the accounting system using double-entry accounting",
			"Record transactions and events relating to inventory, accruals, prepayments, capital structure and finance costs",
			"Calculate customer and/or supplier account balances and reconcile with totals",
			"Compile the relevant business documentation used in banking processes",
			"Process payroll transactions into the organization’s accounting system"
		],
		"Process business transactions and reports using information technology tools": [
			"Enter accurate data into the accounting system",
			"Use relevant Infocomm technology systems and tools effectively for data analysis",
			"Retrieve system reports from the accounting system for management’s use",
			"Assign account codes to transactions in the accounting system",
			"Assist to prepare consolidated financial statements, business activity reports and forecasts for management and external stakeholders"
		],
	}
	//   "Associate business analyst": {
	//     "Identify business needs, systems and requirements": [
	//       'Assist in identifying business needs and system requirements',
	//       'Assist in the in-depth analysis of the business requirements and systems specifications',
	//       'Conduct feasibility studies on proposed solutions',
	//       'Provide analysis to support the development of business cases',
	//       'Support the preparation of proposals for modified or replacement systems',
	//       'Conduct analysis on the risk and benefits for the proposed solutions',
	//    ],
	//    "Analyse systems and propose solutions": [
	//       'Analyse systems and processes to identify enhancement opportunities to resolve system gaps',
	//       'Evaluate the ability of an existing system to support proposed changes and identify systems deficiencies and performance gaps',
	//       'Ensure proposed solutions and/or enhancements are aligned with user needs and requirements',
	//       'Identify and conduct feasibility analysis of proposed solutions and/or enhancements to systems',
	//       'Prepare proposals for proposed solutions and/or enhancements to systems',
	//    ],
	//    "Develop technical specifications": [
	//       'Assist with translating business requirements into functional specifications',
	//       'Document specifications and interfaces between legacy and new systems, and systems enhancements and detailed specifications',
	//       'Act as the liaison between users and technical staff throughout the solution implementation cycle',
	//    ],
	//    "Manage the implementation of new solutions and/or enhancements": [
	//       'Develop test plans and test cases',
	//       'Support users on change control and systems updates and escalate issues to relevant team members for resolution',
	//       'Document post-test evidence of expected results or defects',
	//       'Coordinate training for new users',
	//       'Prepare progress reports and training documents',
	//       'Develop technical documentation of the design documents, coding documents and user manuals',
	//       'Coordinate User Acceptance Testing (UAT) and integration testing in accordance with the implementation plan',
	//       'Ensure adherence to project plan to ensure deliverables are completed on time and in accordance with user and system requirements',
	//    ],
	//   },
	//   "Business Analyst": {
	//     "Identify business needs, systems and requirement": [
	//       'Analyse business technology requirements and specifications against value and risk of potential solutions',
	//       'Translate business needs and requirements into potential Artificial Intelligence (AI) and/or analytics problems',
	//       'Scope Proof-of-Concepts for AI and analytics related use cases and projects',
	//       'Identify suitable technological solutions for the business',
	//       'Balance requests and competing priorities from key stakeholders to maximise the value delivered to the organisation',
	//       'Conduct cost-benefit and risk assessment analyses for proposed solutions to determine suitability of solutions',
	//       'Present business cases defining potential benefits and solutions to increase efficiencies of business processes and associated risks',
	//    ],
	//    "Analyse systems and propose solutions": [
	//       'Examine interactions between systems elements, performance and issues',
	//       'Recommend proposed solutions and/or enhancements to improve and optimise processes, workflows, performance and systems',
	//       'Identify opportunities where AI and analytics can address business and user needs and create value',
	//       'Design the solution blueprints for the specific areas of expertise with the consideration of implications for integration across the entire solution',
	//       'Oversee the evaluation of proposed solutions and/or enhancements to ensure its feasibility, viability and efficiency',
	//       'Evaluate the feasibility, viability and implications of proposed solutions and/or enhancements to systems on the current and future business environment',
	//       'Oversee the development of different components within the proposed solutions and/or enhancements',
	//       'Analyse inter-dependencies and inter-linkages of systems and processes across the organisation',
	//    ],
	//    "Develop technical specifications": [
	//       'Translate business requirements and user needs into functional and technical specifications',
	//       'Develop a roadmap to translate existing system specifications into future-state systems requirements',
	//       'Function as the liaison between users and technical team throughout the implementation cycle',
	//       'Ensure that business requirements are incorporated into the solution design',
	//       'Manage risks associated with new solutions and/or proposed enhancements',
	//       'Guide the design and development teams towards smooth solutions integration',
	//    ],
	//    "Manage the implementation of new solutions and/or enhancements": [
	//       'Apply multi-disciplinary technical expertise to support senior management in complex projects',
	//       'Devise procedures to solve complex operational issues',
	//       'Oversee the translation of requirements documentation to systems requirement specifications',
	//       'Manage the conduct of change management programmes and initiatives to drive the adoption of new and/or enhanced technologies including AI related solutions',
	//       'Act as the main point of contact for escalated issues',
	//       'Review technical documentation of the design documents, coding documents and user manuals',
	//       'Oversee the conduct of User Acceptance Testing (UAT) and integration testing',
	//       'Develop dashboards and provide regular status reports to project managers',
	//       'Review work at critical milestones with team leader or sponsor to maintain their commitment and support',
	//    ],
	//   }
}

export const customAssessmentData = {
	'Project Manager': {
		'problemStatement': 'Our customer is {{clientName}}, a leading player in the {{clientIndustry}} industry. They are looking to implement a customer relationship management (CRM) system to better identify leads, qualify and convert them into opportunities, and track these accounts throughout the customer lifecycle. This project has been codenamed {{projectName}}. While they believe that they have found the best CRM solution, they want to make sure to build a hypothesis and test the product in several markets and with several customers before fully adopting. They want the system fully implemented within a year and are unwilling to increase the budget for {{projectName}} during this year. {{clientPm}} will be your main counterpart on the client team.',
		'customFields': [
			{ label: 'Client Name', key: 'clientName' },
			{ label: 'Client Industry', key: 'clientIndustry' },
			{ label: 'Project Name', key: 'projectName' },
			{ label: 'Client PM', key: 'clientPm' }
		]
	},
	'Product Manager': {
		'problemStatement': '{{productName}} is the flagship product for your company, {{companyName}}. {{productName}} is a market leader in the {{product}} space. The product leadership team agreed to sponsor building a new module for {{productName}}, which has been identified as a major revenue booster. You are the PM in charge of this new module, which has been codenamed {{projectName}}.  A {{newFeature}} feature is currently being executed. This new feature has high visibility among the leadership team but has tight timelines and budgets.',
		'customFields': [
			{ label: 'Product Name', key: 'productName' },
			{ label: 'Company Name', key: 'companyName' },
			{ label: 'Product', key: 'product' },
			{ label: 'Project Name', key: 'projectName' },
			{ label: 'New Feature', key: 'newFeature' }
		]
	}
};

export const industryData = [
	{ label: 'Banks', value: 'BNK' },
	{ label: 'Insurance', value: 'INS' },
	{ label: 'Airlines', value: 'ARL' },
	{ label: 'Hotels', value: 'HTL' },
	{ label: 'SaaS', value: 'SAS' },
	{ label: 'Retail', value: 'RTL' },
	{ label: 'Fiancial Services', key: 'FNS' },
	{ label: 'Technology', value: 'TEC' },
	{ label: 'Manufacturing', value: 'MSG' },
	{ label: 'Construction', value: 'CNS' },
	{ label: 'Healthcare', value: 'HLC' },
	{ label: 'Engineering', value: 'ENG' },
	{ label: 'Marketing and sales', value: 'MAS' },
	{ label: 'Real estate', value: 'RES' }
];

export const salesStagesData = [
	{ value: 'TAR', label: 'Targeting and segmentation' },
	{ value: 'PRO', label: 'Prospecting' },
	{ value: 'MAR', label: 'Marketing outreach' },
	{ value: 'CMP', label: 'Campaign management' },
	{ value: 'LGN', label: 'Lead generation/nurturing' },
	{ value: 'PIT', label: 'Pitching' }
];

export const jobRolesData = [
	{ label: 'SDR', value: 'SDR' },
	{ label: 'Account Executive', value: 'AE' },
	{ label: 'Marketing Manager', value: 'ME' },
	{ label: 'Custom', value: 'Custom' }
];
